import {Action, BreadcrumbType, DataStatus} from 'platform/components';
import {Box, HStack, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {SectionTab, MAIN_TOPBAR_HEIGHT} from '@dms/shared';

import {MyProfileHeader} from './components/MyProfileHeader';
import {MyProfileNavigation} from './components/MyProfileNavigation';

export const PROFILE_SIDEBAR_WIDTH = 80;

interface MyProfileHeaderData {
  title: string;
  subtitle?: string;
  breadcrumbs: BreadcrumbType[];
  actions?: Action[];
}

interface MyProfileTemplateProps {
  isLoading?: boolean;
  isError?: boolean;
  tabs?: SectionTab[];
  children: ReactNode;
  header: MyProfileHeaderData;
  isCreating?: boolean;
}

export function MyProfileTemplate(props: MyProfileTemplateProps) {
  return (
    <HStack height="100%">
      <Box
        position="fixed"
        overflowY="auto"
        width={PROFILE_SIDEBAR_WIDTH}
        top={MAIN_TOPBAR_HEIGHT}
        bottom={0}
        padding={4}
        borderRight="1px solid"
        borderColor="general.separator"
        backgroundColor="general.white"
      >
        <MyProfileNavigation />
      </Box>
      <Box paddingLeft={PROFILE_SIDEBAR_WIDTH} width="100%" backgroundColor="general.white">
        <DataStatus isLoading={props.isLoading} isError={props.isError} minHeight={60}>
          <VStack height="100%">
            <MyProfileHeader
              actions={props.header.actions}
              title={props.header.title}
              breadcrumbs={props.header.breadcrumbs}
              subtitle={props.header.subtitle}
            />
            <Box padding={6} flex={1} position="relative" backgroundColor="general.white">
              <VStack height="100%">
                <Box flex={1}>{props.children}</Box>
              </VStack>
            </Box>
          </VStack>
        </DataStatus>
      </Box>
    </HStack>
  );
}
